import React from 'react';
import './styles.scss';

const PageNotFound = () => {
  return (
    <div styleName="wrapper" data-testid="not-found-page">
      <div styleName="instruction">
        {"We didn't find what you're looking for. Return to our "}
        <a styleName="link" href="/" title="Pear Therapeutics">
          home page
        </a>
        .
      </div>
      <div styleName="pear-down" />
    </div>
  );
};

export default PageNotFound;
